import { Typography, Box, IconButton } from '@mui/material'
import RemoveIcon from '@mui/icons-material/Remove'
import AddIcon from '@mui/icons-material/Add'

interface Props {
  value: number
  updateValue: any
  min?: number
  max?: number
}

const NumericStepper = ({
  value,
  updateValue,
  min,
  max
}: Props): JSX.Element => {
  const setInnerValue = (innerValue: number) => {
    if (
      (min === undefined || innerValue >= min) &&
      (max === undefined || innerValue <= max)
    ) {
      updateValue(innerValue)
    }
  }

  return (
    <Box
      width="124px"
      height="48px"
      borderRadius="60px"
      boxSizing="border-box"
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      margin="30px auto 15px"
      border={1}
      borderColor="divider"
    >
      <IconButton
        onClick={() => {
          setInnerValue(value - 1)
        }}
        size="large"
      >
        <RemoveIcon fontSize="small" />
      </IconButton>
      <Typography variant="h4" component="span">
        {value}
      </Typography>
      <IconButton
        onClick={() => {
          setInnerValue(value + 1)
        }}
        size="large"
      >
        <AddIcon fontSize="small" />
      </IconButton>
    </Box>
  )
}

export default NumericStepper
